import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { removeSessionToken } from '~/features/auth'
import { PublicTemplate } from '~/templates/public'

export const Route = createFileRoute('/_public/logout')({
  component: RouteComponent,
})

function RouteComponent() {
  useEffect(() => {
    removeSessionToken()
    window.location.href = '/'
  }, [])

  return (
    <PublicTemplate>
      <p className="text-center">Logging out...</p>
    </PublicTemplate>
  )
}
